import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {IonContent, ModalController} from '@ionic/angular';
import {ApiService} from '../service/api.service';
import {HelperService} from '../service/helper.service';
import {Subscription} from 'rxjs';
import {WstxcbService} from '../service/wstxcb.service';
import {TranslateConfigService} from '../service/translate-config.service';
import { OnlineListComponent } from '../online-list/online-list.component';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChatComponent implements OnInit, OnDestroy {

  @ViewChild('elListChatHome', {static: false}) elListChat: ElementRef;
  @ViewChild('elBoxChatHome', {static: false}) elBoxChat: ElementRef;
  @ViewChild(IonContent, {static: false}) content: IonContent;

  subscription: Subscription[] = [];
  subscriptionTopic: Subscription;
  subscriptionQueue: Subscription;

  msg = '';
  userInfo = null;

  onlineCount = 0;

  onlineList = [];

  slideOptsPro = {
    slidesPerView: 'auto',
    autoplay: true,
    loop: true
  };

  isDesktop;

  constructor(
    private hpService: HelperService,
    public modalCtr: ModalController,
    public apiService: ApiService,
    private wstxcbService: WstxcbService,
    private translateConfigService: TranslateConfigService,
  ) {
    this.isDesktop = this.hpService.isDesktop;
    this.translateConfigService.setLanguage(this.translateConfigService.getDefaultLanguage());

    this.getOnlineCount();
    this.getOnlineList();

    this.wstxcbService.sendMessage(this.hpService.MINI_MSG_PUBLIC_TX, {});

    // topic/tx => public
    this.subscriptionTopic = this.hpService.getObserverGameTXCB().subscribe(body => {

      // START chat responsive
      if (body.cmd === 10) {
        this.appendNewLineChat({u: body.u, msg: body.m.trim()});
      }
      // END chat responsive

    });
    this.subscription.push(this.subscriptionTopic);

    // user/queue/tx => only user
    this.subscriptionQueue = this.wstxcbService.receiveMessageQueueTX().subscribe(wsData => {
      const body = JSON.parse(wsData.body);

      // START chat list history
      if (body.cmd === 11) {
        const arrChatHis = [];
        body.data.forEach(item => {
          arrChatHis.push({u: item.u, msg: item.m.trim(), status: 1});
        });
        const arrChat = arrChatHis;

        let htmlChat = '';
        arrChat.forEach(item => {
          htmlChat += `<div class="txtChat"><span>${item.u}:</span>${item.msg}</div>`;
        });
        this.elListChat.nativeElement.innerHTML = htmlChat;
        setTimeout(() => {
          this.content.scrollToBottom().then(r => {
          });
        });
      }
      // END chat list history

      // START block chat user
      if (body.cmd === 10) {
        if (body.rs) {
          this.appendNewLineChat({u: '', msg: body.rs, status: 0});
        }
      }
      // END block chat user
    });
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => {
      if (subscription !== null) {
        subscription.unsubscribe();
      }
    });
  }


  appendNewLineChat(item: { u: string; msg: string; status?: number }) {
    // START remove el txt chat first
    const elTxtChatFirst = this.elListChat.nativeElement.querySelectorAll('.txtChat');
    if (elTxtChatFirst && elTxtChatFirst.length > 0) {
      this.elListChat.nativeElement.querySelectorAll('.txtChat')[0].remove();
    }
    // END remove el txt chat first

    // START add element txt chat
    const elTxtChat = document.createElement('div');
    elTxtChat.classList.add('txtChat');
    if (item.status === 0) {
      elTxtChat.classList.add('errorChat');
    }
    elTxtChat.innerHTML = `<span>${item.u}:</span>${item.msg}`;
    this.elListChat.nativeElement.appendChild(elTxtChat);
    // END add element txt chat

    this.content.scrollToBottom(250).then(r => {
    });
  }

  async closeModal() {
      await this.modalCtr.dismiss();
  }

  sendChat(event) {
    event.preventDefault();
    if (this.msg !== '') {
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_CHAT_TX, {u: localStorage.getItem('ur'), m: this.msg});
    }
    this.msg = '';
  }

  async presentAllList() {

    const modal = await this.modalCtr.create({
      component: OnlineListComponent,
      mode: 'md',
      cssClass: 'modal-account modal-all-online'
    });

    return await modal.present();
  }

  getOnlineCount() {
    this.apiService.getOnlineCount().subscribe(
      res => {
        this.onlineCount = res;
      });
  }

  getOnlineList() {
    this.apiService.getOnlineList().subscribe(
      res => {
        this.onlineList = JSON.parse(res);
      });
  }
}
